import { normalizeLongevityPercent } from '../../../utils/onboardingUtils';

export function formatRunwayMonthsDisplay(value) {
  const parsed = parseFloat(value);
  if (!Number.isFinite(parsed)) return `${value} months`;
  const rounded = Math.round(parsed * 10) / 10;
  const display = rounded % 1 === 0 ? String(Math.round(rounded)) : rounded.toFixed(1);
  return `${display} months`;
}

export function formatLongevityBand(percentage, emptyLabel) {
  if (percentage == null || typeof percentage !== 'number' || Number.isNaN(percentage)) return emptyLabel;
  const targetPct = Math.max(0, Math.min(100, percentage));
  if (targetPct > 80) return '>80%';
  if (targetPct < 40) return '<40%';
  return `${targetPct}%`;
}

export function formatLongevitySuccessScoreForDisplay(percentage) {
  return formatLongevityBand(percentage, '—');
}

export const CFP_LONGEVITY_BENCHMARK_PCT = 80;

export function formatLongevityCardScore(percentage) {
  return formatLongevityBand(normalizeLongevityPercent(percentage), '—');
}

export function safeJsonParse(maybeJson) {
  if (typeof maybeJson !== 'string') return null;
  const trimmed = maybeJson.trim();
  if (!trimmed) return null;
  try {
    return JSON.parse(trimmed);
  } catch (e) {
    return null;
  }
}

export function normalizeCheckupAndActionPlan(rawPlan) {
  if (!rawPlan) return null;
  if (typeof rawPlan === 'object' && !Array.isArray(rawPlan)) return rawPlan;
  const parsed = safeJsonParse(rawPlan);
  if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed;
  return null;
}
